import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { AgpmRepository } from '@/store/agpm-state/agpm-state.repository';

interface getAgpmVersionHistoryDataTableStructureProps {
  store: AgpmRepository;
  rowActions?: DataTableRowActions;
}

export const getAgpmVersionHistoryDataTableStructure = ({ store, rowActions }: getAgpmVersionHistoryDataTableStructureProps): DynamicDataTable => {
  const refColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.history.table.ref',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const processStepColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.table.processStep',
    accessorKey: 'etapeProcess',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      if (!value) return { value: 'Non défini', class: 'opacity-70' };
      return { value };
    },
  };

  const versionColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.history.table.version',
    accessorKey: 'version',
    variant: DataTableColumnVariant.TEXT,
  };

  const nomColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.history.table.name',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
    class: 'truncate w-[10vw] min-w-0',
  };

  const anneeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.history.table.year',
    accessorKey: 'annee',
    variant: DataTableColumnVariant.TEXT,
  };

  const refreshedColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.history.table.refreshed',
    accessorKey: 'actualise',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: value ? 'Oui' : 'Non', class: 'text-xs' };
    },
    props: {
      getSeverity: (value: boolean) => {
        if (value) return 'success';
        return 'danger';
      },
    },
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.history.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: `agpm.status.${value}` };
    },
    props: {
      getSeverity: (value: string) => {
        if (value === 'BROUILLON') return 'primary';
        if (value === 'EN_TRAITEMENT') return 'contrast';
        if (value === 'VALIDE') return 'success';
        if (value === 'PUBLIE') return 'info';
        return 'danger';
      },
    },
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.history.table.createdAt',
    accessorKey: 'metadata.createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const updatedAtColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.history.table.updatedAt',
    accessorKey: 'metadata.updatedAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  const acColumnn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'agpm.history.table.ac',
    accessorKey: 'ac.nom',
    variant: DataTableColumnVariant.TEXT,
  };

  return {
    singular: 'agpm.history.table.singular',
    plural: 'agpm.history.table.plural',
    columns: [
      versionColumn,
      refColumn,
      anneeColumn,
      nomColumn,
      acColumnn,
      refreshedColumn,
      statusColumn,
      processStepColumn,
      createdAtColumn,
      updatedAtColumn,
    ],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.setNested('response', row);
    },
    searchableFields: ['ref', 'nom', 'ac.nom'],
    rowActions,
  };
};
